/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Usage_Value_BadgeInputs */



/**
* | output |
* | --- |
* | "Value of tokens used" |
*
* @param {Dashboard_Usage_Value_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_usage_value_badge = /** @type {((inputs?: Dashboard_Usage_Value_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Usage_Value_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wert der verbrauchten Token")
	return /** @type {LocalizedString} */ ("Value of tokens used")
});